<template>
  <!--
    Витрина авторов (Фаза 2c) — публичная лента одобренных клипов на главной ClipCut.
    Само-загрузка через get_showcase_wall (no-auth). Если клипов нет — секция не рендерится.
    Просмотры считаем тихо (log_showcase_view) при первом проигрывании, наружу не показываем.
  -->
  <div class="cc-section showcase-wall" v-if="items.length">
    <h2 class="cc-section-title">{{ $t('showcase_wall.title') }}</h2>
    <p class="sw-subtitle">{{ $t('showcase_wall.subtitle') }}</p>

    <div class="sw-strip">
      <router-link
        v-for="item in items"
        :key="item.short_id"
        :to="'/short/' + item.hash"
        class="sw-card"
      >
        <video
          class="sw-video"
          :src="item.video_url"
          muted
          loop
          playsinline
          preload="metadata"
          autoplay
          @play="onPlay(item)"
        ></video>

        <div class="sw-overlay">
          <div class="sw-caption">{{ item.caption }}</div>
          <div class="sw-author">
            <img v-if="item.author_avatar" :src="item.author_avatar" class="sw-avatar" :alt="item.author_name" />
            <span v-else class="sw-avatar sw-avatar-initial">{{ initial(item.author_name) }}</span>
            <span class="sw-author-name">{{ item.author_name }}</span>
          </div>
        </div>
        <div class="sw-play"><i class="bi bi-play-fill"></i></div>
      </router-link>
    </div>
  </div>
</template>

<script>
import axios from '@/lib/axiosConfig';

export default {
  name: 'ShowcaseWall',
  data() {
    return {
      items: [],
      viewed: {} // short_id => true, чтобы не слать просмотр повторно
    };
  },
  mounted() {
    this.loadWall();
  },
  methods: {
    async loadWall() {
      try {
        const resp = await axios.get('', { params: { action: 'get_showcase_wall', limit: 24 } });
        const items = (resp.data && resp.data.items) || [];
        this.items = Array.isArray(items) ? items : [];
      } catch (e) {
        this.items = []; // тихо: витрина — украшение, не ломаем главную
      }
    },
    initial(name) {
      return (name || '?').trim().charAt(0).toUpperCase();
    },
    onPlay(item) {
      if (this.viewed[item.short_id]) return;
      this.viewed = { ...this.viewed, [item.short_id]: true };
      // Тихий учёт просмотра — результат игнорируем.
      axios.get('', { params: { action: 'log_showcase_view', short_id: item.short_id } }).catch(() => {});
    }
  }
};
</script>

<style scoped>
.showcase-wall {
  margin-top: 8px;
}
.sw-subtitle {
  text-align: center;
  color: #6b7280;
  margin: -8px 0 18px;
  font-size: 0.95rem;
}

/* Горизонтальная полка вертикальных клипов — ощущение «живой движухи». */
.sw-strip {
  display: flex;
  gap: 14px;
  overflow-x: auto;
  padding: 4px 2px 14px;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
}
.sw-strip::-webkit-scrollbar { height: 6px; }
.sw-strip::-webkit-scrollbar-thumb { background: rgba(124, 77, 255, 0.3); border-radius: 3px; }

.sw-card {
  position: relative;
  flex: 0 0 auto;
  width: 170px;
  aspect-ratio: 9 / 16;
  border-radius: 16px;
  overflow: hidden;
  background: #0f1117;
  box-shadow: 0 8px 22px rgba(20, 12, 50, 0.18);
  scroll-snap-align: start;
  text-decoration: none;
  display: block;
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}
.sw-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 14px 30px rgba(124, 77, 255, 0.32);
}

.sw-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.sw-overlay {
  position: absolute;
  left: 0; right: 0; bottom: 0;
  padding: 26px 11px 10px;
  background: linear-gradient(to top, rgba(8, 9, 14, 0.92) 12%, rgba(8, 9, 14, 0.55) 55%, rgba(8, 9, 14, 0) 100%);
  pointer-events: none;
}
.sw-caption {
  color: #fff;
  font-size: 0.78rem;
  line-height: 1.28;
  font-weight: 600;
  margin-bottom: 8px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.sw-author {
  display: flex;
  align-items: center;
  gap: 7px;
}
.sw-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  border: 1.5px solid rgba(255, 255, 255, 0.55);
}
.sw-avatar-initial {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #7c4dff, #d6379e);
  color: #fff;
  font-size: 0.74rem;
  font-weight: 700;
}
.sw-author-name {
  color: #e9ecf2;
  font-size: 0.76rem;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sw-play {
  position: absolute;
  top: 9px; right: 9px;
  width: 26px; height: 26px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.4);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  opacity: 0.85;
  pointer-events: none;
}

@media (max-width: 575px) {
  .sw-card { width: 142px; }
}
</style>
